/*
 * <product-recommendations> custom element.
 *
 * On connect, fetches Shopify's algorithmic product recommendations via the
 * Section Rendering API (data-url points at routes.product_recommendations_url
 * with ?section_id=...&product_id=...&intent=related). The returned HTML is the
 * fully re-rendered section; we swap in the fresh <product-recommendations>
 * inner markup so the `recommendations.*` Liquid branch replaces the
 * server-rendered fallback.
 *
 * After swapping innerHTML, we dispatch `recommendations:loaded` so the section's
 * inline carousel controller can re-bind prev/next to the new nodes (the original
 * binding pointed at the now-removed fallback nodes).
 *
 * If the fetch yields no usable markup (no recommendations AND no fallback), the
 * element removes itself so the section collapses cleanly instead of showing an
 * empty shell.
 */
class ProductRecommendations extends HTMLElement {
  connectedCallback() {
    if (this.dataset.fetched === 'true') return;
    const url = this.dataset.url;
    if (!url) return;
    this.dataset.fetched = 'true';

    fetch(url)
      .then((response) => {
        if (!response.ok) throw new Error('recommendations fetch failed: ' + response.status);
        return response.text();
      })
      .then((text) => {
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const fresh = doc.querySelector('product-recommendations');

        if (fresh && fresh.innerHTML.trim().length) {
          this.innerHTML = fresh.innerHTML;
          this.dispatchEvent(
            new CustomEvent('recommendations:loaded', { bubbles: true })
          );
        } else if (!this.innerHTML.trim().length) {
          this.remove();
        }
      })
      .catch(() => {
        /* Network/parse failure: keep the server-rendered fallback in place. */
      });
  }
}

if (!customElements.get('product-recommendations')) {
  customElements.define('product-recommendations', ProductRecommendations);
}
